import React, { useState } from 'react';
import TextHeader from 'components/CustomText/TextHeader';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import UploadModal from 'components/uploadFile/UploadModal';
import { useDispatch, useSelector } from 'react-redux';
import MsgBox from 'components/MsgBox/MsgBox';
import { CREATE_CTC_CTI } from 'store/key';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import CustomButton from 'components/CustomInput/Button';
import useQuery from 'hooks/useQuery';
import { CTI_CREATED } from 'utility/frontendMessage';

const SLayout = styled.div`
    padding: 10px;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 55px;
    overflow: auto;
    bottom: 5px;
`;

const SHeaderLayout = styled.div`
    height: 55px;
    display: flex;
    padding: 0px 15px;
    align-items: center;
    background: #ecebf3;
    overflow: 'hidden';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
`;

const SMainLayout = styled.div`
    height: 100%;
    position: relative;
    overflow: hidden;
`;

const useStyles = makeStyles((theme) => ({
    page: {
        padding: 15,
    },
    itemContent: {
        paddingTop: 20,
    },
    subItem: {
        paddingTop: 10,
    },
    textSubHeader: {
        paddingBottom: 10,
    },
    leftColumn: {
        paddingRight: 30,
    },
    rightColumn: {
        paddingLeft: 30,
    },
    italicText: {
        paddingTop: 5,
        fontStyle: 'italic',
    },
}));

const CTCCTISubmissionForm = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const systemMessage = useSelector((state) => state.systemMessage.systemMessage);
    const showDialog = useDialog();
    const dispatch = useDispatch();
    const id = Number(useQuery('id'));

    const CTCDefaultFromData = {
        CTCNewExpiyeDate: {
            id: '0',
            value: null,
            label: 'New Expiry Date',
            name: 'CTCNewExpiyeDate',
            type: 'date',
            validators: ['isRequired'],
        },
        certificateNo: {
            id: '1',
            value: '',
            name: 'certificateNo',
            label: 'Certificate No',
            type: 'input',
            validators: ['isRequired'],
            maxLength: 255,
        },
        upload: {
            id: '2',
            value: [],
            type: 'upload',
            downloadType: 'ctc',
        },
    };

    const CTIDefaultFromData = {
        CTINewExpiyeDate: {
            id: '0',
            value: null,
            label: 'New Expiry Date',
            name: 'CTINewExpiyeDate',
            type: 'date',
            validators: ['isRequired'],
        },
        policyNo: {
            id: '1',
            value: '',
            name: 'policyNo',
            label: 'Policy No',
            type: 'input',
            validators: ['isRequired'],
            maxLength: 255,
        },
        upload: {
            id: '2',
            value: [],
            type: 'upload',
            downloadType: 'cti',
        },
    };
    const [CTCFormData, setCTCFormData] = useState([CTCDefaultFromData]);
    const [CTIFormData, setCTIFormData] = useState([CTIDefaultFromData]);
    const [warningMsg, setWarningMsg] = useState(null);
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);

    const getCtcData = () => {
        let tempCtc = [];
        CTCFormData.forEach((data) => {
            tempCtc.push({
                expiryDtm: new Date(data.CTCNewExpiyeDate.value),
                certNo: data.certificateNo.value,
                uploadFileId: data.upload.uploadTempId,
                appId: id,
            });
        });
        return tempCtc;
    };

    const getCtiData = () => {
        let tempCti = [];
        CTIFormData.forEach((data) => {
            tempCti.push({
                expiryDtm: new Date(data.CTINewExpiyeDate.value),
                policyNo: data.policyNo.value,
                uploadFileId: data.upload.uploadTempId,
                appId: id,
            });
        });
        return tempCti;
    };

    const checkCtcData = () => {
        let errorSubmitCondition = []; //[part of the input fields missing, all of them missing]
        let ctcCanSubmit = true;
        let allFieldsBlank = false;
        const copyCTCFormData = [...CTCFormData];
        for (let i of copyCTCFormData) {
            if (!i.upload.uploadTempId && !i.CTCNewExpiyeDate.value && !i.certificateNo.value) {
                allFieldsBlank = true;
            }
            if (!i.upload.uploadTempId) {
                i.upload.error = true;
                ctcCanSubmit = false;
            } else {
                if (!i.CTCNewExpiyeDate.value) {
                    ctcCanSubmit = false;
                } else if (!i.certificateNo.value) {
                    ctcCanSubmit = false;
                } else {
                    ctcCanSubmit = true;
                }
            }
        }
        if (!ctcCanSubmit) {
            setCTCFormData(copyCTCFormData);
        }
        errorSubmitCondition = [ctcCanSubmit, allFieldsBlank];
        return errorSubmitCondition;
    };

    const checkCtiData = () => {
        let errorSubmitCondition = []; //[part of the input fields missing, all of them missing]
        let ctiCanSubmit = true;
        let allFieldsBlank = false;
        const copyCTIFormData = [...CTIFormData];
        for (let i of copyCTIFormData) {
            if (!i.upload.uploadTempId && !i.CTINewExpiyeDate.value && !i.policyNo.value) {
                allFieldsBlank = true;
            }
            if (!i.upload.uploadTempId) {
                i.upload.error = true;
                ctiCanSubmit = false;
            } else {
                if (!i.CTINewExpiyeDate.value) {
                    ctiCanSubmit = false;
                } else if (!i.policyNo.value) {
                    ctiCanSubmit = false;
                } else {
                    ctiCanSubmit = true;
                }
            }
        }
        if (!ctiCanSubmit) {
            setCTIFormData(copyCTIFormData);
        }
        errorSubmitCondition = [ctiCanSubmit, allFieldsBlank];
        return errorSubmitCondition;
    };

    const uploadSuccess = () => {
        showDialog({
            description: CTI_CREATED,
            disableCancelButton: true,
        });
        history.push('/');
    };

    const onSubmit = () => {
        if (!CTCFormData.length && !CTIFormData.length) {
            return showDialog({
                description: systemMessage.ctcCtiRequired,
                disableCancelButton: true,
            });
        }

        const ctcValidCheck = checkCtcData();
        const ctiValidCheck = checkCtiData();
        let ctcValid = ctcValidCheck[0];
        let allCTCFieldsBlank = ctcValidCheck[1];
        let ctiValid = ctiValidCheck[0];
        let allCTIFieldsBlank = ctiValidCheck[1];
        if (!ctcValid || !ctiValid) {
            let errorMessage = `Please remove the incomplete ${ctcValid ? 'CTI' : 'CTC'} record before submission`;
            if (allCTIFieldsBlank || allCTCFieldsBlank) {
                errorMessage = `If there is only one type of submission, please remove the unnecessary row by clicking the rubbish bin icon.`;
            }
            setForceErrorDisplay(true);
            return showDialog({
                description: errorMessage,
                disableCancelButton: true,
            });
        }

        const data = {
            ctc: getCtcData(),
            cti: getCtiData(),
        };
        dispatch({
            type: CREATE_CTC_CTI,
            payload: {
                data: data,
                id: id,
                callback: (response) => {
                    if (response.status !== 400) {
                        uploadSuccess();
                    }
                },
            },
        });
    };

    const close = () => {
        history.goBack();
    };

    const onRemoveCtc = (rowIndex) => {
        const copyFormData = [...CTCFormData];
        copyFormData[rowIndex].upload.value = [];
        copyFormData[rowIndex].upload.uploadTempId = null;

        setCTCFormData(copyFormData);
    };

    const onRemoveCti = (rowIndex) => {
        const copyFormData = [...CTIFormData];
        copyFormData[rowIndex].upload.value = [];
        copyFormData[rowIndex].upload.uploadTempId = null;

        setCTIFormData(copyFormData);
    };

    return (
        <SMainLayout>
            <Grid style={{ height: '100%', overflow: 'hidden' }}>
                <SHeaderLayout>
                    <div style={{ marginRight: 15 }}>
                        <CustomButton onClick={onSubmit}>Submit</CustomButton>
                    </div>
                    <div style={{ marginRight: 15 }}>
                        <CustomButton type="cancel" onClick={close}>
                            Close
                        </CustomButton>
                    </div>
                </SHeaderLayout>
                {warningMsg ? (
                    <MsgBox
                        type={warningMsg.type}
                        message={warningMsg.message}
                        footerActions={warningMsg.footerActions}
                        title={warningMsg.title}
                        closePopup={() => setWarningMsg(null)}
                    />
                ) : null}

                <SLayout>
                    <Paper>
                        <div style={{ padding: 10 }}>
                            <Grid>
                                <TextHeader style={{ textAlign: 'center', marginBottom: 10 }}>
                                    Certificate for Clinical Trial / Medicinal Test (CTC)/ Clinical Trial Insurance
                                    (CTI) Report Form
                                </TextHeader>
                            </Grid>
                            <Grid className={classes.itemContent}>
                                <UploadModal
                                    groupType="CTC"
                                    formData={CTCFormData}
                                    forceErrorDisplay={forceErrorDisplay}
                                    setFormData={(data) => setCTCFormData(data)}
                                    setWarningMsg={setWarningMsg}
                                    defaultFormData={CTCDefaultFromData}
                                    title="Certificate for Clinical Trial / Medicinal Test (CTC)"
                                    onRemove={onRemoveCtc}
                                />
                                <Grid className={classes.itemContent}></Grid>
                                <UploadModal
                                    groupType="CTI"
                                    formData={CTIFormData}
                                    forceErrorDisplay={forceErrorDisplay}
                                    setFormData={(data) => setCTIFormData(data)}
                                    setWarningMsg={setWarningMsg}
                                    defaultFormData={CTIDefaultFromData}
                                    title="Clinical Trial Insurance (CTI)"
                                    onRemove={onRemoveCti}
                                />
                            </Grid>
                        </div>
                    </Paper>
                </SLayout>
            </Grid>
        </SMainLayout>
    );
};

export default CTCCTISubmissionForm;
